import { Table, Tag, Space, message } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import {
  deletePaymentModes,
  getpaymentModesById,
} from "../../../api/paymentMode";
import { PaymentModeType } from "./paymentType";
import { AddEditPayment } from "./AddEditPayment";
import EditButton from "../../UI/EditButton/editbutton";
import DeleteButton from "../../UI/DeleteButton/deletebutton";
import DeleteModal from "../../UI/ModalComponent/DeleteModal/deletemodal";
import { AxiosResponse } from "axios";
interface inventoryProps {
  PaymentModeMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  filter: boolean | undefined;
  search: string;
  paginatedPaymentMode: any;
  setPaginatedPaymentMode: Dispatch<any>;
  isPaymentModeLoading: boolean;
  tableKey: string;
}
interface PaymentInterface {
  id: number;
  mode: string;
  isActive: boolean;
}

const PaymentList = ({
  PaymentModeMutation,
  page,
  setPage,
  filter,
  search,
  paginatedPaymentMode,
  setPaginatedPaymentMode,
  isPaymentModeLoading,
  tableKey,
}: inventoryProps) => {
  const [t] = useTranslation("common");
  const [Payment, setPayment] = useState<PaymentModeType>();
  const [openPayment, setOpenPayment] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState<any>();
  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);
  const [, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);
  const [nameToDelete, setNameToDelete] = useState<any>();

  useEffect(() => {
    page > prevPage &&
      maxPage < page &&
      PaymentModeMutation({
        limit: page * 8 + 8,
        q: search,
        isActive: filter,
      }).then((res) => {
        if (page > maxPage) setMaxPage(page);
        setPaginatedPaymentMode(res.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filter]);

  const getpaymentMutation = useMutation("getpayment", getpaymentModesById);
  function fillPayment(id: any) {
    getpaymentMutation.mutate(id, {
      onSuccess: (res) => {
        setPayment(res.data);
        setOpenPayment(true);
      },
    });
  }

  const onError = (error: any, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };

  const deletePaymentModesMutation = useMutation(
    "deletePaymentModes",
    deletePaymentModes,
    {
      onSuccess: () => {
        PaymentModeMutation({
          limit: page * 8 + 8,
          q: search,
          isActive: filter,
        }).then((res) => {
          setPaginatedPaymentMode(res.data);
          message.success("Complete successfully");
        });
      },
      onError,
    }
  );

  const Deletepayment = (id: string | undefined, mode: string): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(mode);
  };

  const handleOk = () => {
    if (idToDelete) {
      deletePaymentModesMutation.mutate({ id: idToDelete });
    }
    setOpen(false);
  };

  const columns: ColumnsType<PaymentInterface> = [
    {
      title: `${t("payment-method")}`,
      dataIndex: "mode",
      key: "mode",

      className: "table-header",
    },
    {
      title: `${t("status")}`,
      dataIndex: "isActive",
      align: "center",
      key: "isActive",
      width: "5rem",
      render: (record: any) =>
        record ? (
          <Tag className="active">Active</Tag>
        ) : (
          <Tag className="inactive">Inactive</Tag>
        ),
    },
    {
      title: `${t("action")}`,
      align: "center",
      key: "action",
      fixed: "right",
      width: "5rem",
      render: (record: any) => (
        <Space>
          <EditButton
            onClick={() => {
              fillPayment(record.id);
              setSelectedPayment(record.id);
            }}
          />
          <DeleteButton
            onClick={() => Deletepayment(record?.id, record?.mode)}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={nameToDelete}
        onOk={handleOk}
      />
      {openPayment && Payment && (
        <AddEditPayment
          openPayment={openPayment}
          Payment={Payment}
          setOpenPayment={setOpenPayment}
          id={selectedPayment}
          page={page}
          filter={filter}
          search={search}
          PaymentModeMutation={PaymentModeMutation}
          setPaginatedPaymentMode={setPaginatedPaymentMode}
        />
      )}

      <Table
        key={tableKey}
        scroll={{ x: 1000 }}
        columns={columns}
        dataSource={paginatedPaymentMode}
        loading={isPaymentModeLoading}
        pagination={{ pageSize: 8 }}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        onChange={(selectedPage) => {
          setPrevPage(page);
          setPage(selectedPage?.current ?? 1);
        }}
        rowKey={(record) => record.id}
      />
    </>
  );
};

export default PaymentList;
